import React, { useCallback, useEffect, useState } from 'react'
import { CheckBox, FormCustom, Input } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'
import { doToast } from '../../../utils'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button'
import { Modal } from 'react-bootstrap'
import { doRequestGet, doRequestPost } from '../../../api'
import ReactTableBootstrap from 'react-table-bootstrap'
import LoadingIcon from '../../../components/loading/LoadingIcon'
import SelectCustom from '../../../components/select-custom/SelectCustom'

const ZoneEventName = ({ zone }) => {
  const isSoldOut = parseInt(zone.sold_out) === 1

  return <div>
    <div className='d-flex'>
      <div style={{
        width: 20,
        height: 20,
        backgroundColor: zone.color_event_zone,
        borderRadius: 5
      }} className='align-self-center me-2'></div>
      <div className='align-self-center'>
        <strong style={{
          color: zone.color_event_zone,
          textDecoration: isSoldOut ? 'line-through' : 'none'
        }}>{zone.name_event_zone}</strong>
        {isSoldOut && <>
          <span> - </span>
          <span className="badge bg-danger">Sold Out</span>
        </>}
      </div>
    </div>
    <div>{zone.name_event}</div>
  </div>
}

const SaleForm = ({ rowId, setReload }) => {
  const [row, setRow] = useState({
    p_name_customer: '',
    p_last_name_customer: '',
    p_email_customer: '',
    p_phone_customer: '',
    p_details: [],
    p_id_format_pay: '1',
    p_amount_format_pay: '',
    p_has_format_pay_add: 0,
    p_id_format_pay_add: '',
    p_amount_format_pay_add: '',
    p_ticket_free: '',
    p_public_customer: 0,
  })
  const [ready, setReady] = useState(false);
  const [modalShow, setModalShow] = useState(false)
  const [zones, setZones] = useState([])
  const [zonesProcessing, setZonesProcessing] = useState(true)
  const [loading, setLoading] = useState(false)
  const [loadingSearch, setLoadingSearch] = useState(false)
  const [formatPay, setFormatPay] = useState([])
  const [modalZoneDetail, setModalZoneDetail] = useState(false)
  const [zoneDetailRows, setZoneDetailRows] = useState([])
  const [zoneDetailSelected, setZoneDetailSelected] = useState({
    p_event_zone_detail: []
  })
  const [coupon, setCoupon] = useState({
    id_coupon: '',
    type_coupon: '',
    amount_coupon: '',
    id_event: '',
  })
  const [searchCoupon, setSearchCoupon] = useState('')

  const getSubtotal = useCallback(() => {
    if (parseInt(row.p_ticket_free) === 1) {
      return {
        total: "0.00",
        amount_coupon: "0.00",
        total_before_coupon: "0.00",
      }
    }

    let amount_coupon = 0
    let total = 0;
    row.p_details.forEach(r => {
      if (!isNaN(r.quantity) && !isNaN(r.price_event_zone)) {
        total += r.price_event_zone * r.quantity
      }

      if (coupon.id_coupon && coupon.id_event === r.id_event) {
        amount_coupon = parseFloat(coupon.amount_coupon)
        if (coupon.type_coupon === 'PERCENTAGE') {
          amount_coupon = (total * (amount_coupon / 100))
        }
      }
    })

    let total_before_coupon = total;
    total -= amount_coupon

    let cargo_por_orden = 0
    if (
      parseInt(row.p_id_format_pay) !== 1 &&
      parseInt(row.p_id_format_pay) !== 6 &&
      parseInt(row.p_id_format_pay) !== 10 &&
      parseInt(row.p_id_format_pay_add) !== 1 &&
      parseInt(row.p_id_format_pay_add) !== 6 &&
      parseInt(row.p_id_format_pay_add) !== 10
    ) {
      cargo_por_orden = parseFloat(((total * 0.0349) * 1.16) + 4.64)
      console.log('cargo_por_orden', cargo_por_orden)
      total += cargo_por_orden
    }

    return {
      total: total.toFixed(2),
      amount_coupon: amount_coupon.toFixed(2),
      total_before_coupon: total_before_coupon.toFixed(2),
      cargo_por_orden: cargo_por_orden.toFixed(2),
    }
  }, [row.p_details, coupon, row.p_ticket_free, row.p_id_format_pay, row.p_id_format_pay_add])

  const dataSubmit = useMemo(() => {
    return {
      ...row,
      p_id_coupon: coupon.id_coupon,
      p_type_coupon: coupon.type_coupon,
      p_amount_coupon: coupon.amount_coupon,
      p_cargo_por_orden: getSubtotal().cargo_por_orden,
      p_details: row.p_details.map(r => {
        return {
          id_type_event_zone: r.id_type_event_zone,
          id_event_zone: r.id_event_zone,
          quantity: r.quantity,
          rows: parseInt(r.id_type_event_zone) === 1 ? '' : r.p_event_zone_detail.map(ezd => {
            return ezd.id_event_zone_detail
          }).join(),
          name_event_zone: r.name_event_zone,
        }
      })
    }
  }, [row, coupon, getSubtotal])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/sale/insert',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/sale/' + rowId,
    rowId: rowId
  })

  // Mantener concordancia entre cortesía y método de pago
  useEffect(() => {
    // Si está marcada la cortesía, forzar método de pago 6 y quitar pagos adicionales
    if (parseInt(row.p_ticket_free) === 1) {
      setRow(prev => ({
        ...prev,
        p_id_format_pay: '6',
        p_has_format_pay_add: 0,
        p_id_format_pay_add: '',
        p_amount_format_pay: '',
        p_amount_format_pay_add: '',
      }))
    }
  }, [row.p_ticket_free, setRow])

  useEffect(() => {
    // Si seleccionan método de pago 6, activar cortesía y limpiar pagos adicionales
    if (parseInt(row.p_id_format_pay) === 6 && parseInt(row.p_ticket_free) !== 1) {
      setRow(prev => ({
        ...prev,
        p_ticket_free: 1,
        p_has_format_pay_add: 0,
        p_id_format_pay_add: '',
        p_amount_format_pay: '',
        p_amount_format_pay_add: '',
      }))
    }
  }, [row.p_id_format_pay, row.p_ticket_free, setRow])

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          const getFormatPay = await doRequestGet({
            url: '/format-pay/public'
          })
          setFormatPay(getFormatPay.data)

          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready])

  const getCoupon = async () => {
    try {
      setLoadingSearch(true)
      const requestCoupon = await doRequestPost({
        url: '/event/coupon/search',
        data: {
          p_key_coupon: searchCoupon,
        }
      })

      if (requestCoupon.response !== 'success') {
        doToast({
          response: 'warning',
          message: 'No existe cupón',
          toast,
        })
        setCoupon({
          id_coupon: '',
          type_coupon: '',
          amount_coupon: '',
          id_event: '',
        })
      } else {
        const couponData = requestCoupon.data
        console.log('couponData', couponData)
        setCoupon({
          id_coupon: couponData.id_coupon,
          type_coupon: couponData.type_coupon,
          amount_coupon: couponData.amount_coupon,
          id_event: couponData.id_event,
        })
      }
    } catch (error) {
      console.log('error', error)
      doToast({
        response: 'error',
        message: 'No se pudo consultar el cupón',
        toast,
      })
      setSearchCoupon('')
      setCoupon({
        id_coupon: '',
        type_coupon: '',
        amount_coupon: '',
        id_event: '',
      })
    } finally {
      setLoadingSearch(false)
    }
  }

  const removeCoupon = async () => {
    setCoupon({
      id_coupon: '',
      type_coupon: '',
      amount_coupon: '',
      id_event: '',
    })
    setSearchCoupon('')
  }

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom textButton="Generar Venta" onSubmit={() => {
      if (row.p_details.length === 0) {
        doToast({
          response: 'warning',
          message: 'Debe agregar al menos una zona para la venta',
          toast
        })
        return
      }

      if (!row.p_id_format_pay) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar un método de pago',
          toast
        })
        return
      }

      if (row.p_has_format_pay_add && !row.p_id_format_pay_add) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar un método de pago adicional',
          toast
        })
        return
      }

      if (row.p_has_format_pay_add) {
        if (Number((parseFloat(row.p_amount_format_pay) + parseFloat(row.p_amount_format_pay_add)).toFixed(2)) !== Number(getSubtotal().total)) {
          doToast({
            response: 'warning',
            message: 'Los montos de los pagos no coinciden con el total',
            toast
          })
          return
        }
      }

      // Validaciones de cortesía
      const isCourtesy = parseInt(row.p_ticket_free) === 1 || parseInt(row.p_id_format_pay) === 6
      if (parseInt(row.p_ticket_free) === 1 && parseInt(row.p_id_format_pay) !== 6) {
        doToast({
          response: 'warning',
          message: 'Cortesía requiere método de pago Cortesía (6)',
          toast
        })
        return
      }
      if (isCourtesy && parseInt(row.p_has_format_pay_add) === 1) {
        doToast({
          response: 'warning',
          message: 'No se permite pago adicional en cortesía',
          toast
        })
        return
      }

      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <CheckBox
        text={parseInt(row.p_public_customer) === 1 ? 'Desmarcar cliente público' : 'Marcar cliente público'}
        classNameParent="col-md-12 mb-2"
        value={row.p_public_customer}
        onChange={e => setRow({ ...row, p_public_customer: e.target.checked ? 1 : 0 })}
        id="chk-public-customer"
      />
      {row.p_public_customer !== 1 && <>
        <Input
          text="Nombres"
          placeholder="Nombres"
          classNameParent="col-md-6 mb-3"
          required
          invalid="El campo es obligatorio."
          value={row.p_name_customer}
          onChange={e => setRow({ ...row, p_name_customer: e.target.value })}
          maxLength={100}
        />
        <Input
          text="Apellidos"
          placeholder="Apellidos"
          classNameParent="col-md-6 mb-3"
          required
          invalid="El campo es obligatorio."
          value={row.p_last_name_customer}
          onChange={e => setRow({ ...row, p_last_name_customer: e.target.value })}
          maxLength={100}
        />
        <Input
          text="Email"
          placeholder="Email"
          type="email"
          classNameParent="col-md-6 mb-3"
          required
          invalid="El campo es obligatorio."
          value={row.p_email_customer}
          onChange={e => setRow({ ...row, p_email_customer: e.target.value })}
          maxLength={150}
        />
        <Input
          text="Telefono"
          placeholder="Telefono"
          classNameParent="col-md-6 mb-3"
          required
          invalid="El campo es obligatorio."
          value={row.p_phone_customer}
          onChange={e => setRow({ ...row, p_phone_customer: e.target.value })}
          maxLength={20}
        />
      </>}
      <CheckBox
        text={parseInt(row.p_ticket_free) === 1 ? 'Desmarcar cortesía' : 'Marcar como cortesía'}
        classNameParent="col-md-6 mb-2"
        checked={row.p_ticket_free}
        onChange={e => {
          const isChecked = e.target.checked
          console.log('isChecked', isChecked)
          if (isChecked) {
            setRow({
              ...row,
              p_ticket_free: 1,
              p_id_format_pay: '6',
              p_has_format_pay_add: 0,
              p_id_format_pay_add: '',
              p_amount_format_pay: '',
              p_amount_format_pay_add: '',
            })
          } else {
            setRow({ ...row, p_ticket_free: 0, p_id_format_pay: '', p_has_format_pay_add: 0, p_id_format_pay_add: '', p_amount_format_pay: '', p_amount_format_pay_add: '' })
          }
        }}
        id="chk-cortesia"
      />
      <SelectCustom
        valueId={row.p_id_format_pay}
        keyName="format_pay"
        options={formatPay}
        setRow={setRow}
        row={row}
        selectText="Método de Pago"
        selectPops={{
          classNameParent: 'col-md-12 mb-3',
          disabled: parseInt(row.p_ticket_free) === 1
        }}
        addLegend={false}
        onChangeAdd={(e) => {
          console.log('método de pago seleccionado', e)
          if (e.id_format_pay === 6) {
            setRow({ ...row, p_ticket_free: 1, p_id_format_pay: '6', p_has_format_pay_add: 0, p_id_format_pay_add: '', p_amount_format_pay: '', p_amount_format_pay_add: '' })
          }
        }}
      />
      {parseInt(row.p_has_format_pay_add) === 1 && <Input
        type="number"
        text="Monto"
        placeholder="Monto"
        classNameParent="col-md-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_amount_format_pay}
        onChange={e => setRow({ ...row, p_amount_format_pay: e.target.value })}
        min="1"
      />}
      <CheckBox
        text={parseInt(row.p_has_format_pay_add) === 1 ? 'Quitar Pago Adicional' : 'Agregar Pago Adicional'}
        classNameParent="col-md-6 mb-3"
        checked={row.p_has_format_pay_add}
        onChange={e => {
          const checked = e.target.checked
          // No permitir pago adicional si es cortesía por checkbox o método de pago
          if (checked && (parseInt(row.p_ticket_free) === 1 || parseInt(row.p_id_format_pay) === 6)) {
            doToast({
              response: 'warning',
              message: 'No se permite pago adicional en cortesía',
              toast
            })
            return
          }
          setRow({ ...row, p_has_format_pay_add: checked ? 1 : 0, p_id_format_pay_add: '' })
        }}
        disabled={parseInt(row.p_ticket_free) === 1 || parseInt(row.p_id_format_pay) === 6}
        id="chk-format-pay-add"
      />
      {parseInt(row.p_has_format_pay_add) === 1 && <SelectCustom
        valueId={row.p_id_format_pay_add}
        keyName="format_pay"
        options={formatPay.filter(fp => fp.id_format_pay !== 6)}
        setRow={setRow}
        onChangeKey={'p_id_format_pay_add'}
        row={row}
        selectText="Método de Pago Adicional"
        selectPops={{
          classNameParent: 'col-md-12 mb-3',
        }}
      />}
      {parseInt(row.p_has_format_pay_add) === 1 && <Input
        type="number"
        text="Monto"
        placeholder="Monto"
        classNameParent="col-md-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_amount_format_pay_add}
        onChange={e => setRow({ ...row, p_amount_format_pay_add: e.target.value })}
        min="1"
      />}
      <div className="col-12 mb-2">
        <Button onClick={async _ => {
          setZones([])
          setZonesProcessing(true)
          setModalShow(true)
          const getZones = await doRequestGet({
            url: '/sale/get/events'
          })

          // solo se agrega la zona general
          /* const getZoneGeneral = getZones.data.filter(r => {
            return parseInt(r.id_type_event_zone) === 1
          }) */

          // todas la zonas
          const getZoneGeneral = getZones.data

          setZones(getZoneGeneral)
          setZonesProcessing(false)
        }}>
          <i className="fa fa-search me-2"></i>
          <span>Buscar Zonas</span>
        </Button>
      </div>
      <div className="col-12">
        <div className="table-responsive">
          <table className="table table-sm table-hover table-striped">
            <thead>
              <tr className="bg-dark">
                <th className="text-white">Entrada</th>
                <th className="text-white">Cantidad</th>
                <th className="text-white">Subtotal</th>
                <th className="text-white"></th>
              </tr>
            </thead>
            <tbody>
              {React.Children.toArray(row.p_details.map(r => {
                return <tr>
                  <td>
                    <ZoneEventName zone={r} />
                  </td>
                  {parseInt(r.id_type_event_zone) === 1 ? <td>
                    <Input
                      type="number"
                      step="1"
                      min="1"
                      max={r?.event_zone_detail?.length}
                      value={r.quantity}
                      className="text-center"
                      required
                      onChange={e => {
                        const value = parseInt(e.target.value)
                        if (value > 0 && value <= r.event_zone_detail.length) {
                          setRow({
                            ...row,
                            p_details: row.p_details.map(p => {
                              if (p.id_event_zone === r.id_event_zone) {
                                return {
                                  ...p,
                                  quantity: value
                                }
                              }

                              return p
                            })
                          })
                        }
                      }}
                    />
                  </td> : <td className='text-center'>
                    <div>{r.quantity}</div>
                    <div>
                      {r.p_event_zone_detail.map(ezd => {
                        return <div>
                          <strong>{ezd.name_event_zone_detail}</strong>
                        </div>
                      })}
                    </div>
                  </td>}
                  <td className='text-center'>
                    <span>
                      {(!isNaN(parseFloat(r.price_event_zone)) && !isNaN(parseFloat(r.quantity)) ? r.price_event_zone * r.quantity : 0)} {r.name_money}
                    </span>
                  </td>
                  <td className='text-center'>
                    <Button variant="danger" className='text-white' onClick={_ => {
                      setRow({
                        ...row,
                        p_details: row.p_details.filter(p => p.id_event_zone !== r.id_event_zone)
                      })
                    }
                    }>
                      <i className="fa fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              }))}
              {!isNaN(parseInt(coupon.id_coupon)) && <>
                <tr>
                  <td></td>
                  <td align="center">Subtotal antes de descuento</td>
                  <td align="center">
                    {getSubtotal().total_before_coupon} MXN
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td align="center">Cupón Descuento</td>
                  <td align="center">
                    <div className='badge bg-info'>
                      {getSubtotal().amount_coupon} MXN
                    </div>
                  </td>
                  <td></td>
                </tr>
              </>}
              {parseInt(row.p_id_format_pay) !== 1 && parseInt(row.p_id_format_pay) !== 6 && parseInt(row.p_id_format_pay) !== 10 && parseInt(row.p_id_format_pay_add) !== 1 && parseInt(row.p_id_format_pay_add) !== 6 && parseInt(row.p_id_format_pay_add) !== 10 ? <tr>
                <td></td>
                <td className='text-right'>
                  <span>Cargo por Orden</span>
                </td>
                <td className='text-center'>
                  <div>{getSubtotal().cargo_por_orden} MXN</div>
                </td>
                <td></td>
              </tr> : <></>}
              <tr>
                <td></td>
                <td className='text-right'>
                  <span>Total</span>
                </td>
                <td className='text-center'>
                  <h3 className='font-weight-bold'>{getSubtotal().total} MXN</h3>
                </td>
                <td></td>
              </tr>
              {parseInt(row.p_ticket_free) !== 1 && <tr>
                <td></td>
                <td align="center">Aplicar Cupón</td>
                <td align="center"><strong>
                  <Input
                    classNameParent="col-md-6"
                    className="form-control"
                    placeholder="Código de descuento"
                    value={searchCoupon} onChange={e => setSearchCoupon(e.target.value)}
                    disabled={!isNaN(parseInt(coupon.id_coupon))}
                    append={[
                      isNaN(parseInt(coupon.id_coupon)) ? <Button variant="info" className='text-white' onClick={getCoupon} style={{ zIndex: 0 }}>Aplicar</Button> : <Button variant="danger" className='text-white' onClick={removeCoupon} style={{ zIndex: 0 }}>Quitar Cupón</Button>
                    ]}
                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                    style={{
                      minWidth: 50
                    }}
                  />
                </strong></td>
                <td></td>
              </tr>}
            </tbody>
          </table>
          <tbody>
          </tbody>
        </div>
      </div>
    </FormCustom>
    <Modal show={modalShow} onHide={_ => setModalShow(false)} backdrop="static" size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title as="div">Buscar zonas para eventos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <LoadingIcon />}
        <ReactTableBootstrap
          head={[
            [
              {
                name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', style: {
                  width: '100px'
                },
                render: zone => {
                  const isSoldOut = parseInt(zone.sold_out) === 1
                  if (isSoldOut) return <></>

                  const findZone = row.p_details.find(r => r.id_event_zone === zone.id_event_zone)

                  if (findZone) {
                    return <Button variant="dark">
                      <i className="fa fa-check"></i>
                    </Button>
                  }

                  return <Button variant="primary" onClick={async _ => {
                    setLoading(true)
                    if (parseInt(zone.id_type_event_zone) === 1) {
                      const getZone = await doRequestGet({
                        url: `/event/zone/${zone.id_event_zone}/get/public`
                      })

                      if (!getZone.data?.event_zone_detail?.length > 0) {
                        doToast({
                          response: 'warning',
                          message: 'No hay entradas disponibles',
                          toast
                        })
                        setLoading(false)
                        return;
                      }

                      setRow({
                        ...row,
                        p_details: [
                          ...row.p_details,
                          {
                            ...getZone.data,
                            quantity: 1
                          }
                        ]
                      })
                    } else {
                      const getZone = await doRequestGet({
                        url: `/event/zone/${zone.id_event_zone}/get/public`
                      })

                      if (getZone.data.event_zone_detail.length === 0) {
                        doToast({
                          response: 'warning',
                          message: 'No hay entradas disponibles',
                          toast
                        })
                        setLoading(false)
                        return;
                      } else {
                        setZoneDetailSelected({
                          ...getZone.data,
                          p_event_zone_detail: []
                        })
                        setZoneDetailRows(getZone.data.event_zone_detail.map(d => {
                          return {
                            id_event_zone_detail: d.id_event_zone_detail,
                            name_event_zone_detail: d.column_event_zone + d.row_event_zone,
                          }
                        }))
                        setModalZoneDetail(true)
                      }
                    }
                    setLoading(false)
                  }}>
                    <i className="fa fa-plus"></i>
                  </Button>
                }
              },
              {
                name: 'name_event_zone', text: 'Zona', render: zone => {
                  return <ZoneEventName zone={zone} />
                }
              },
              {
                name: 'price_event_zone', text: 'Precio', align: 'center', render: r => {
                  return <span>
                    {r.price_event_zone} {r.name_money}
                  </span>
                }
              },
            ]
          ]}
          rows={zones}
          isProcessing={zonesProcessing}
        />
      </Modal.Body>
    </Modal>

    <Modal show={modalZoneDetail} onHide={_ => setModalZoneDetail(false)} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title as="div">Seleccionar entradas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectCustom
          valueId={zoneDetailSelected.p_event_zone_detail}
          keyName="event_zone_detail"
          options={zoneDetailRows}
          setRow={setZoneDetailSelected}
          row={zoneDetailSelected}
          selectText="Seleccionar entradas"
          selectPops={{
            classNameParent: 'col-md-12 mb-3',
          }}
          isMulti
          showEnabled={false}
          isSort={false}
        />
        <div className="col-12 text-center">
          <Button onClick={async _ => {
            if (zoneDetailSelected.p_event_zone_detail.length === 0) {
              doToast({
                response: 'warning',
                message: 'Debe seleccionar al menos una entrada',
                toast
              })
              return
            }

            setRow({
              ...row,
              p_details: [
                ...row.p_details,
                {
                  ...zoneDetailSelected,
                  p_event_zone_detail: zoneDetailSelected.p_event_zone_detail.map(ezd => {
                    const findRow = zoneDetailRows.find(zdr => parseInt(zdr.id_event_zone_detail) === parseInt(ezd))

                    return {
                      id_event_zone_detail: ezd,
                      name_event_zone_detail: findRow.name_event_zone_detail
                    }
                  }),
                  quantity: zoneDetailSelected.p_event_zone_detail.length
                }
              ]
            })
            setModalShow(false)
            setModalZoneDetail(false)
          }}>
            <i className="fa fa-search me-2"></i>
            <span>Agregar</span>
          </Button>
        </div>
      </Modal.Body>
    </Modal>

    {loadingSearch && <LoadingIcon />}
  </ReactPlaceholder>
}

SaleForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  SaleForm
};